import { render, staticRenderFns } from "./FooterLanding.vue?vue&type=template&id=72771c10&scoped=true&"
import script from "./FooterLanding.vue?vue&type=script&lang=js&"
export * from "./FooterLanding.vue?vue&type=script&lang=js&"
import style0 from "./FooterLanding.vue?vue&type=style&index=0&id=72771c10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72771c10",
  null
  
)

export default component.exports